// @flow

export const ClearClientContext = "CLEAR_CLIENT_CONTEXT";

export const GetClientContext = "GET_CLIENT_CONTEXT";
export const GetClientContextSuccess = "GET_CLIENT_CONTEXT_SUCCESS";
export const GetClientContextError = "GET_CLIENT_CONTEXT_ERROR";

export const SetClientContext = "SET_CLIENT_CONTEXT";
